// Server
import {
  arrayBufferToCBOR,
  arrayBufferToJSON,
  convertArrayBufferToBase64,
  convertBase64ToArrayBuffer,
  decodeAuthenticatorData,
} from "./utils";

const checkValidChallenge = (email, challenge) => {
  const expectedChallenge = localStorage.getItem(email + "_challenge");

  if (challenge === expectedChallenge) {
    console.log("Challenge matched", challenge === expectedChallenge);
  } else {
    console.log("Challenge did not match: ", challenge, expectedChallenge);
    throw new Error("Challenge did not match: ", challenge, expectedChallenge);
  }
};

async function validateSignature(
  clientDataJSONInput,
  authenticatorDataInput,
  signature,
  publicKey
) {
  // Import the public key for verification
  try {
    const importedKey = await window.crypto.subtle.importKey(
      "spki", // Use 'spki' for public keys
      publicKey,
      {
        name: "ECDSA",
        namedCurve: "P-256", // Use P-256 curve for ES256
        hash: { name: "SHA-256" }, // Specify the hash algorithm
      },
      false,
      ["verify"]
    );

    var clientDataHash = new Uint8Array(
      await crypto.subtle.digest("SHA-256", clientDataJSONInput)
    );

    // concat authenticatorData and clientDataHash
    var authenticatorData = new Uint8Array(authenticatorDataInput);
    var signedData = new Uint8Array(
      authenticatorData.length + clientDataHash.length
    );
    signedData.set(authenticatorData);
    signedData.set(clientDataHash, authenticatorData.length);

    var usignature = new Uint8Array(signature);
    var rStart = usignature[4] === 0 ? 5 : 4;
    var rEnd = rStart + 32;
    var sStart = usignature[rEnd + 2] === 0 ? rEnd + 3 : rEnd + 2;
    var r = usignature.slice(rStart, rEnd);
    var s = usignature.slice(sStart);
    var rawSignature = new Uint8Array([...r, ...s]);

    var verified = await crypto.subtle.verify(
      { name: "ECDSA", namedCurve: "P-256", hash: { name: "SHA-256" } },
      importedKey,
      rawSignature,
      signedData.buffer
    );

    console.log("foo: validateSignature: ", verified);
  } catch (error) {
    console.error("Error importing key:", error);
  }
}

export const getCredentialIdBuffer = (email) =>
  convertBase64ToArrayBuffer(
    localStorage.getItem(email + "_credentialIdBuffer")
  );

export const toServerCreateCredentials = async (email, credential) => {
  const attestationObject = credential.response.attestationObject;
  const clientDataJSON = arrayBufferToJSON(credential.response.clientDataJSON);
  const challenge = clientDataJSON.challenge;

  const attestationObjectCBOR = await arrayBufferToCBOR(attestationObject);
  console.log("foo: attestationObjectCBOR: ", attestationObjectCBOR);

  const credentialId = credential.id;
  const credentialBufferBase64 = convertArrayBufferToBase64(credential.rawId);
  const clientDataJSONBase64 = convertArrayBufferToBase64(
    credential.response.clientDataJSON
  );
  const attestationObjectBase64 = convertArrayBufferToBase64(attestationObject);

  const publicKeyBase64 = convertArrayBufferToBase64(
    credential.response.getPublicKey()
  );

  checkValidChallenge(email, challenge);

  console.log(
    "Saving to server...",
    credentialId,
    clientDataJSON,
    attestationObjectCBOR
  );

  localStorage.setItem(email + "_credentialId", credentialId);
  localStorage.setItem(email + "_credentialIdBuffer", credentialBufferBase64);
  localStorage.setItem(email + "_publicKey", publicKeyBase64);
  localStorage.setItem(email + "_clientDataJSONBase64", clientDataJSONBase64);
  localStorage.setItem(
    email + "_attestationObjectBase64",
    attestationObjectBase64
  );
};

export const toServerVerifySecondLogin = async (email, credential) => {
  const clientDataJSONBuffer = await credential.response.clientDataJSON;
  const clientDataJSON = arrayBufferToJSON(clientDataJSONBuffer);

  const authenticatorDataBuffer = await credential.response.authenticatorData;
  const authenticatorData = decodeAuthenticatorData(authenticatorDataBuffer);

  const credentialId = credential.id;

  const signature = await credential.response.signature;

  const previousPublicKey = convertBase64ToArrayBuffer(
    localStorage.getItem(email + "_publicKey")
  );

  const challenge = clientDataJSON.challenge;

  console.log(
    "Verifying second login...",
    credentialId,
    clientDataJSON,
    authenticatorData
  );

  checkValidChallenge(email, challenge);

  await validateSignature(
    clientDataJSONBuffer,
    authenticatorDataBuffer,
    signature,
    previousPublicKey
  );
};

export const getChallengeFromServer = (email) => {
  const challenge = new Uint8Array(32);
  window.crypto.getRandomValues(challenge);
  let challengeString = btoa(String.fromCharCode.apply(null, challenge));

  // Make the Base64 string URL-safe and associate it with the email
  challengeString = challengeString
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

  localStorage.setItem(email + "_challenge", challengeString);

  return challenge;
};

export const emailHasCredentialsOnServer = (email) => {
  // Should probably also check device info as well. So that
  const pk = localStorage.getItem(email + "_publicKey");
  return pk !== null;
};
